module.exports = __webpack_public_path__ + "static/img/PU page top img_mobile.6f3ec858.jpg";